"use strict";
/*
 * This file is part of ORY Editor.
 *
 * ORY Editor is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * ORY Editor is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with ORY Editor.  If not, see <http://www.gnu.org/licenses/>.
 *
 * @license LGPL-3.0
 * @copyright 2016-2018 Aeneas Rekkas
 * @author Aeneas Rekkas <aeneas+oss@aeneas.io>
 *
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var uuid_1 = require("uuid");

var CropLandscape_1 = __importDefault(require("@material-ui/icons/CropLandscape"));

var Component_1 = __importDefault(require("./Component"));

if (process.env.NODE_ENV !== 'production') {
  console.warn( // tslint:disable-next-line:max-line-length
  'WARNING! Obsolete plugin loaded. \'ory/editor/core/layout/parallax-background\' has been deprecated, please use the new \'ory/editor/core/layout/background\' plugin instead! Make sure to migrate your state manually by changing the plugin name before you switch.');
}

var createPlugin = function createPlugin(settings) {
  return {
    Component: function Component(props) {
      return React.createElement(Component_1.default, __assign({}, props, settings));
    },
    name: 'ory/editor/core/layout/parallax-background',
    version: '0.0.1',
    text: 'Parallax Background (deprecated)',
    IconComponent: React.createElement(CropLandscape_1.default, null),
    createInitialChildren: function createInitialChildren() {
      return {
        id: uuid_1.v4(),
        rows: [{
          id: uuid_1.v4(),
          cells: [{
            content: {
              plugin: settings.defaultPlugin,
              state: settings.defaultPlugin.createInitialState()
            },
            id: uuid_1.v4()
          }]
        }]
      };
    },
    handleFocusNextHotKey: function handleFocusNextHotKey() {
      return Promise.reject();
    },
    handleFocusPreviousHotKey: function handleFocusPreviousHotKey() {
      return Promise.reject();
    }
  };
};

exports.default = createPlugin;